var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { SafariWriteDirectionUtility } from '@inter-ikea-kompis/utilities';
import { Text } from '@inter-ikea-kompis/component-text';
import SummaryPageFooterStyle from './SummaryPageFooterStyle.js';
/**
 * @deprecated This component has been deprecated, use Main Footer instead.
 */
export default class SummaryPageFooter extends KompisElement {
    constructor() {
        super(...arguments);
        // Adds margins on all sides of SummaryPageFooter when true.
        this.enableMargins = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const direction = SafariWriteDirectionUtility.getWriteDirection(this);
        return html `
			<style>
				${SummaryPageFooterStyle.getStyle({
            theme: this.theme,
            enableMargins: this.enableMargins,
            direction
        })}
			</style>
			<footer>${this.getText()}</footer>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    getText() {
        // Setting dir=ltr so that the '©' will stay on the left side in when in rtl.
        return html `
			<kompis-text .theme="${this.theme}" .type="${ThemeFontStyleTypeEnum.bodyMedium}">
				<span dir="ltr">© Inter IKEA Systems B.V. 1999-${this.getCurrentYear()}</span>
			</kompis-text>
		`;
    }
    getCurrentYear() {
        return new Date().getFullYear();
    }
}
__decorate([
    property({ type: Object, required: true })
], SummaryPageFooter.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], SummaryPageFooter.prototype, "enableMargins", void 0);
//# sourceMappingURL=SummaryPageFooter.js.map